/* eslint-disable i18next/no-literal-string */
import { initGlobalTracker } from 'hooks/use-google-analytics';
import { isBrowser } from 'src/utils/misc-utils';
import { isExperimentsDebugMode } from './is-debug-mode';
import { Group } from './types';

const log = (gaPayload: any): void => {
  if (!isExperimentsDebugMode()) {
    return;
  }

  console.info(
    `%cDUTCHIE_EXPERIMENT%c %o`,
    'font-weight: bold; color: #1D352C; background-color: #5EA68C; padding: 2px 4px;',
    '',
    gaPayload
  );
};

const getEventLabel = (experimentId: string, group: Omit<Group, Group.ineligible>): string => {
  switch (group) {
    case Group.control:
      return `${experimentId}-control`;
    case Group.experiment:
      return `${experimentId}-experiment`;
  }

  return `${experimentId}-invalid`;
};

const trackEvent = (
  eventAction: 'experiment_conversion' | 'experiment_enrollment' | 'experiment_trial',
  experimentId: string,
  group: Group
): void => {
  if (!isBrowser()) {
    return;
  }

  initGlobalTracker();

  if (!(typeof window.ga === 'function') || group === Group.ineligible) {
    return;
  }

  const payload = {
    hitType: 'event',
    eventCategory: 'experiment',
    eventAction,
    eventLabel: getEventLabel(experimentId, group),
  };

  log(payload);

  if (process.env.NODE_ENV === 'production') {
    window.ga('send', payload);
  }
};

export const onEnrollment = (experimentId: string, group: Group): void =>
  trackEvent('experiment_enrollment', experimentId, group);

export const onTrialStart = (experimentId: string, group: Group): void =>
  trackEvent('experiment_trial', experimentId, group);

export const onConversion = (experimentId: string, group: Group): void =>
  trackEvent('experiment_conversion', experimentId, group);
